<template>
  <div>
    <template v-if="element.type == 'input'">
      <a-input
        :disabled="element.options.disabled"
        :placeholder="element.options.placeholder"
        :style="{width: element.options.width}"
        v-model="element.options.defaultValue"
      />
    </template>

    <template v-if="element.type == 'textarea'">
      <a-input
        :disabled="element.options.disabled"
        :placeholder="element.options.placeholder"
        :rows="5"
        :style="{width: element.options.width}"
        type="textarea"
        v-model="element.options.defaultValue"
      />
    </template>

    <template v-if="element.type == 'number'">
      <a-input-number
        :controls-position="element.options.controlsPosition"
        :disabled="element.options.disabled"
        :style="{width: element.options.width}"
        v-model="element.options.defaultValue"
      />
    </template>

    <template v-if="element.type == 'radio'">
      <a-radio-group
        :disabled="element.options.disabled"
        :style="{width: element.options.width}"
        v-model="element.options.defaultValue"
      >
        <a-radio
          :key="item.value + index2"
          :label="item.value"
          :style="{display: element.options.inline ? 'inline-block' : 'block'}"
          v-for="(item, index2) in element.options.options"
        >{{ element.options.showLabel ? item.label : item.value }}</a-radio>
      </a-radio-group>
    </template>

    <template v-if="element.type == 'checkbox'">
      <a-checkbox-group
        :disabled="element.options.disabled"
        :style="{width: element.options.width}"
        v-model="element.options.defaultValue"
      >
        <a-checkbox
          :key="item.value + index1"
          :label="item.value"
          :style="{display: element.options.inline ? 'inline-block' : 'block'}"
          v-for="(item, index1) in element.options.options"
        >{{ element.options.showLabel ? item.label : item.value }}</a-checkbox>
      </a-checkbox-group>
    </template>

    <template v-if="element.type == 'time'">
      <a-time-picker
        :arrow-control="element.options.arrowControl"
        :clearable="element.options.clearable"
        :defaultValue="element.options.defaultValue"
        :disabled="element.options.disabled"
        :editable="element.options.editable"
        :end-placeholder="element.options.endPlaceholder"
        :is-range="element.options.isRange"
        :placeholder="element.options.placeholder"
        :readonly="element.options.readonly"
        :start-placeholder="element.options.startPlaceholder"
        :style="{width: element.options.width}"
        :valueFormat="element.options.format"
        v-model="element.options.defaultValue"
      />
    </template>

    <template v-if="element.type == 'date'">
      <a-date-picker
        :clearable="element.options.clearable"
        :disabled="element.options.disabled"
        :editable="element.options.editable"
        :end-placeholder="element.options.endPlaceholder"
        :is-range="element.options.isRange"
        :placeholder="element.options.placeholder"
        :readonly="element.options.readonly"
        :start-placeholder="element.options.startPlaceholder"
        :style="{width: element.options.width}"
        :type="element.options.type"
        v-model="element.options.defaultValue"
      />
    </template>

    <template v-if="element.type == 'rate'">
      <a-rate
        :allow-half="element.options.allowHalf"
        :disabled="element.options.disabled"
        :max="element.options.max"
        v-model="element.options.defaultValue"
      />
    </template>

    <template v-if="element.type == 'color'">
      <a-color-picker
        :disabled="element.options.disabled"
        :show-alpha="element.options.showAlpha"
        v-model="element.options.defaultValue"
      />
    </template>

    <template v-if="element.type == 'select'">
      <a-select
        :allowClear="element.options.clearable"
        :disabled="element.options.disabled"
        :mode="element.options.multiple ? 'multiple' : 'default'"
        :placeholder="element.options.placeholder"
        :style="{width: element.options.width||'250px'}"
        v-model="element.options.defaultValue"
      >
        <a-select-option
          :key="`select${key}`"
          :value="item.value"
          v-for="(item,key) in element.options.options"
        >{{element.options.showLabel?item.label:item.value}}</a-select-option>
      </a-select>
      <!-- <a-select default-value="lucy" style="width: 120px">
        <a-select-option value="lucy">Lucy</a-select-option>
      </a-select>-->
    </template>

    <template v-if="element.type=='switch'">
      <a-switch :disabled="element.options.disabled" v-model="element.options.defaultValue" />
    </template>

    <template v-if="element.type=='slider'">
      <a-slider
        :disabled="element.options.disabled"
        :max="element.options.max"
        :min="element.options.min"
        :range="element.options.range"
        :show-input="element.options.showInput"
        :step="element.options.step"
        :style="{width: element.options.width}"
        v-model="element.options.defaultValue"
      />
    </template>

    <template v-if="element.type=='imgupload'">
      <fm-upload
        :disabled="element.options.disabled"
        :height="element.options.size.height"
        :style="{'width': element.options.width}"
        :width="element.options.size.width"
        domain="xxx"
        token="xxx"
        v-model="element.options.defaultValue"
      />
    </template>

    <template v-if="element.type=='file'">
      <FileUpload :element="element" />
    </template>

    <template v-if="element.type == 'cascader'">
      <a-cascader
        :clearable="element.options.clearable"
        :disabled="element.options.disabled"
        :options="element.options.remote?element.options.remoteOptions:element.options.options"
        :placeholder="element.options.placeholder"
        :show-all-levels="element.options.showAllLevels"
        :style="{width: element.options.width}"
        v-model="element.options.defaultValue"
      />
    </template>

    <template v-if="element.type == 'editor'">
      <vue-editor :style="{width: element.options.width}" v-model="element.options.defaultValue" />
    </template>

    <template v-if="element.type=='blank'">
      <div
        style="height: 50px;color: #999;background: #eee;line-height:50px;text-align:center;"
      >{{ $t('fm.components.fields.blank') }}</div>
    </template>

    <template v-if="element.type === 'text'">
      <span
        :style="{
          'font-size': element.options.font_size,
          'font-family': element.options.font_family,
          'font-weight': element.options.font_weight,
          'color': element.options.font_color
        }"
      >{{ element.options.defaultValue }}</span>
    </template>

    <template v-if="element.type === 'divider'">
      <a-divider :content-position="element.options.content_position" :direction="element.options.direction">
        <span
          :style="{
            'font-size': element.options.font_size,
            'font-family': element.options.font_family,
            'font-weight': element.options.font_weight,
            'color': element.options.font_color
          }"
        >{{ element.options.defaultValue }}</span>
      </a-divider>
    </template>
  </div>
</template>

<script>
  import FmUpload from './Upload'
  import FileUpload from './Upload/file'
  export default {
    name: 'WidgetFormFields',
    /* eslint-disable */
    props: ['element'],
    components: {
      FmUpload,
      FileUpload
    }
  }
</script>
